import React from 'react';
import { TouchableOpacity, View ,Image , Dimensions, Linking ,ScrollView } from 'react-native';
import {Appbar,Text} from 'react-native-paper';



const coverHeight = (Dimensions.get('window').width*4.51/10)*95/100;

export default class App extends React.Component {
  render() {
    return (
      <View style={{backgroundColor:'white',height:'100%'}}>
    <Appbar.Header style={{height:50,backgroundColor:'white'}} >
      <Appbar.Action icon="menu" color='#3a3635' onPress={() => this.props.navigation.openDrawer()} />
      <Appbar.Content title='درباره ما'/>
      <Appbar.Action style={{marginLeft:'auto'}} icon="arrow-left" color='#3a3635' onPress={() => {this.props.navigation.goBack()}} />
    </Appbar.Header>


       <Image style={{height:coverHeight, width:'95%',marginTop:15,marginLeft:'auto',marginRight:'auto'}} source={require('../assets/about.jpg')}  resizeMode='contain'/>


      <ScrollView style={{backgroundColor:'#f2e5d7',marginHorizontal:10,borderTopRightRadius:30,borderTopLeftRadius:30,overflow:'hidden',height:'100%',elevation:8,marginTop:15}}>

      <View>
      <Text style={{marginLeft:30, marginRight:30, marginTop:25,fontSize:14}}>
      برای ورزش کردن و داشتن یک سبک زندگی سالم و وپرنشاط نباید هیچ محدودیتی وجود داشته باشد. اگر نمی توانید برنامه زمانی مشخصی برای ورزش کردن داشته باشید، کلاس های ورزشی تون و از دست می دهید و یا از برنامه سانس های ورزشی اطلاع ندارید و از داشتن برنامه متنوع ورزشی لذت می برید، فیت ویز راه حل شماست. {'\n'}
      فیت ویز اولین اپلیکیشن عضویت منعطف در فعالیت های ورزشی است. شما می توانید با فعالسازی یکی از اشتراک های موجود به رشته های  ورزشی متنوع دسترسی داشته باشید، خیلی ساده برنامه روزانه خودتون را برای تمرین ورزشی تنظیم کنید، و  با بهترین مربی ها به صورت آنلاین و یا در باشگاه مورد نظر خودتون به همراه دوستانتان از ورزش لذت ببرید
      </Text>
      </View>

      <View style={{flexDirection:"row",marginLeft:'auto',marginRight:'auto', marginBottom:35}}>
      <TouchableOpacity style={{marginLeft:15, marginRight:15, marginTop:25,}} onPress={ ()=> Linking.openURL('https://www.instagram.com/fitwayz.ir/')}><Image style={{width:25, height:25}} resizeMode='stretch' source={require('../assets/ig.png')}/></TouchableOpacity>
      <TouchableOpacity style={{marginLeft:15, marginRight:15, marginTop:25,}} onPress={ ()=> Linking.openURL('https://www.facebook.com/fitwayz.group')}><Image style={{width:25, height:25}} resizeMode='stretch' source={require('../assets/fb.png')}/></TouchableOpacity>
      <TouchableOpacity style={{marginLeft:15, marginRight:15, marginTop:25,}} onPress={ ()=> Linking.openURL('https://twitter.com/fitwayz')}><Image style={{width:25, height:25}} resizeMode='stretch' source={require('../assets/twitter.png')}/></TouchableOpacity>
      </View>
      </ScrollView>

      </View>
    );
  }
}


